import styled from "@emotion/styled";

export const CustomHeaderWrapper = styled.div(({ theme: { designTokens: DT }, isApplyCustomLayout }) => {
    if (!isApplyCustomLayout) return ''
    return `
        .u-header {
            border-bottom: none;
        }
    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomHeader/style.jsx